/**
 * CUSTOMER-R4.5 — local referral conversion flags (no rewards).
 * Attribution itself is Worker startapp; this only coordinates client events.
 */
const REFERRED_SESSION_KEY = "as_r45_referred_session";
const FIRST_ORDER_EMITTED_KEY = "as_r45_referred_first_order";

function store(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function markReferredSession(): void {
  store()?.setItem(REFERRED_SESSION_KEY, "1");
}

export function isReferredSession(): boolean {
  return store()?.getItem(REFERRED_SESSION_KEY) === "1";
}

export function consumeReferredFirstOrderSlot(): boolean {
  const s = store();
  if (!s || s.getItem(REFERRED_SESSION_KEY) !== "1") return false;
  if (s.getItem(FIRST_ORDER_EMITTED_KEY) === "1") return false;
  s.setItem(FIRST_ORDER_EMITTED_KEY, "1");
  return true;
}
